export default "__VITE_ASSET__C4MOW5gO__"